// Auto-generated
export const duration0 = '0ms';
export const duration100 = '100ms';
export const duration200 = '200ms';
export const duration300 = '300ms';
export const duration400 = '400ms';
export const duration500 = '500ms';
export const duration600 = '600ms';
export const duration700 = '700ms';
export const duration800 = '800ms';
export const duration900 = '900ms';
